import { FC, useState } from 'react'
import { DurationKeys } from 'hooks/useMute'
import MuteOptions, { muteDuration } from 'hooks/useMute/MuteOptions'
import { cn, RadioGroup } from '@wellesley/ui'
import { isMuted, isBlocked, useRelationship } from 'user'

import ReportLayout from '../ReportLayout'

import Option from './Option'
import { NOT_FAN_ACTION, NOT_FAN_OPTIONS } from './options'

import { type TNotFanReport } from './types'

const NotFanReport: FC<TNotFanReport> = ({
  user,
  action,
  onMute,
  onBlock,
  onChange,
}) => {
  const { relationship } = useRelationship({ userId: user.id })

  const [duration, setDuration] = useState<DurationKeys>('forever')

  const handleMute = () => {
    if (!user) return

    const muteTime = muteDuration[duration as DurationKeys]

    void onMute(muteTime)
  }

  const onSubmit = () => {
    const isMute = action === 'mute'

    if (isMute) {
      handleMute()
    } else onBlock()
  }

  return (
    <ReportLayout
      rightButtonTitle={action}
      onRightButtonClick={() => void onSubmit()}
    >
      <RadioGroup
        value={action}
        onValueChange={(val) => onChange(val as NOT_FAN_ACTION)}
      >
        {NOT_FAN_OPTIONS.map((item) => {
          const isMuteItem = item.value === 'mute'
          const isBlockItem = item.value === 'block'

          return (
            <Option
              key={item.value}
              {...item}
              user={user}
              onChange={onChange}
              isDisabled={
                isBlockItem ? isBlocked(relationship) : isMuted(relationship)
              }
              className={cn('gap-xxxs flex flex-col text-gray-700', {
                'pb-s border-b border-gray-200': isBlockItem,
                'pt-s': isMuteItem,
              })}
            >
              <div className="gap-xxxs mt-xxs flex">
                {action === 'mute' && isMuteItem && (
                  <MuteOptions
                    selected={duration as DurationKeys}
                    onSelect={setDuration}
                  />
                )}
              </div>
            </Option>
          )
        })}
      </RadioGroup>
    </ReportLayout>
  )
}

export default NotFanReport
